enum pendingStatus {
    pending = 1, // หยุดการทำงาน
    resume = 2, // เริ่มการทำงาน
}
export default pendingStatus
